import axios from "axios";
import AutoRefreshToken from "../autoRefreshToken";

export default class AzureAutoRefreshToken extends AutoRefreshToken{
    _expired = 9 * 60 * 1000;

    async _requestToken(){
        const res = await axios.get('/azure/token', {
            headers: {
                "content-type": "application/x-www-form-urlencoded"
            }
        });

       return res.data.data.issueToken;
    }
}
